module.exports = __webpack_public_path__ + "img/user_card_vip.0539afce.png";